import { LoaderFunctionArgs, Params } from "react-router";
import { get, getImage } from "./AureaApi";

type GetCustomerDevicesParams = LoaderFunctionArgs & {
  params: Params<"customerId">;
};
type getTmsImagesParams = LoaderFunctionArgs & {
  params: Params<"tmsId">;
};
type loadTmsImageParams = LoaderFunctionArgs & {
  params: Params<"sensorImageId">;
};

export type TreescoutDevice = {
  id: string;
  reseller_id: number;
  customer_id: number;
  previous_customer_ids: number[];
  sending_messages: string;
  serial_number: string;
  created_at: string;
  updated_at: string;
};

export type SensorImage = {
  camera_serial_number: string;
  created_at: string;
  drive_id: string;
  id: string;
  position: {
    coordinates: number[];
    type: string;
  };
  raw_image_available: boolean;
  resolution: {
    horizontal_pixels: number;
    vertical_pixels: number;
  };
  timestamp: string;
  vehicle_parameters: {
    heading: number;
    position: {
      coordinates: number[];
      type: string;
    };
    speed_m_s: number;
  };
};

export type TreescoutDeviceList = TreescoutDevice[];

export async function getCustomerDevices({
  params: { customerId },
}: GetCustomerDevicesParams): Promise<null | TreescoutDeviceList> {
  return get<TreescoutDeviceList>(
    `/v1/customer/${customerId}/tms_installation`,
  );
}

export function getTmsImages({ params: { tmsId } }: getTmsImagesParams) {
  return get<SensorImage[]>(
    `/v1/tms_installation/${tmsId}/sensor_image?limit=5`,
  );
}

export async function loadTmsImage({
  params: { sensorImageId },
}: loadTmsImageParams): Promise<{
  url: Promise<string>;
}> {
  const url = getImage(`/v1/sensor_image/${sensorImageId}/webp`);
  return { url };
}
